import type { Template } from "@/types";

export const LA_05_H2_V3: Template[] = [
    {
        id: "la-05-h2v3-01",
        name: "LA 01 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 139, y: 47, width: 196, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 139, y: 348, width: 196, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 47, width: 195, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 348, width: 195, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 827, y: 0, width: 374, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-02",
        name: "LA 02 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 153, y: 0, width: 371, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 46, width: 195, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 190, width: 195, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 46, width: 196, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 190, width: 196, height: 293, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-03",
        name: "LA 03 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 153, y: 0, width: 371, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 46, width: 195, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 190, width: 195, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 46, width: 196, height: 293, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 347, width: 196, height: 136, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-04",
        name: "LA 04 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 202, y: 51, width: 273, height: 430, rotation: 0, imageRotation: 0 },
            { id: "2", x: 812, y: 51, width: 405, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 812, y: 343, width: 96, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 915, y: 343, width: 200, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1123, y: 343, width: 94, height: 137, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-05",
        name: "LA 05 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 146, y: 51, width: 384, height: 243, rotation: 0, imageRotation: 0 },
            { id: "2", x: 146, y: 302, width: 251, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 405, y: 302, width: 125, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 79, width: 237, height: 375, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 79, width: 236, height: 375, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-06",
        name: "LA 06 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 60, y: 68, width: 555, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 841, y: 68, width: 346, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 841, y: 304, width: 110, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 304, width: 110, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1077, y: 304, width: 110, height: 159, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-07",
        name: "LA 07 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 88, width: 224, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 232, y: 88, width: 495, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 735, y: 88, width: 114, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 735, y: 270, width: 114, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 857, y: 88, width: 495, height: 355, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-08",
        name: "LA 08 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 212, width: 185, height: 285, rotation: 0, imageRotation: 0 },
            { id: "2", x: 192, y: 212, width: 383, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 583, y: 212, width: 185, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 775, y: 212, width: 382, height: 285, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1165, y: 212, width: 187, height: 285, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-09",
        name: "LA 09 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 93, y: 46, width: 279, height: 440, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 46, width: 278, height: 440, rotation: 0, imageRotation: 0 },
            { id: "3", x: 666, y: 46, width: 278, height: 440, rotation: 0, imageRotation: 0 },
            { id: "4", x: 952, y: 46, width: 306, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 952, y: 271, width: 306, height: 215, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h2v3-10",
        name: "LA 10 - H2V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 88, width: 224, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 232, y: 88, width: 495, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 735, y: 88, width: 495, height: 355, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1238, y: 88, width: 114, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1238, y: 269, width: 114, height: 174, rotation: 0, imageRotation: 0 }
        ],
    }
];